import { render, staticRenderFns } from "./CourseInfo.vue?vue&type=template&id=6a9eb587&scoped=true"
import script from "./CourseInfo.vue?vue&type=script&lang=js"
export * from "./CourseInfo.vue?vue&type=script&lang=js"
import style0 from "./CourseInfo.vue?vue&type=style&index=0&id=6a9eb587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9eb587",
  null
  
)

export default component.exports